/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SignupImport } from './routes/signup'
import { Route as RequestPasswordResetImport } from './routes/request-password-reset'
import { Route as PasswordLinkSentImport } from './routes/password-link-sent'
import { Route as AppImport } from './routes/_app'
import { Route as AuthResetPasswordImport } from './routes/auth/reset-password'
import { Route as AuthLoginImport } from './routes/auth/login'
import { Route as AppWelcomeImport } from './routes/_app/welcome'
import { Route as AppTermsImport } from './routes/_app/terms'
import { Route as AppSubscriptionImport } from './routes/_app/subscription'
import { Route as AppSignupDetailsImport } from './routes/_app/signup-details'
import { Route as AppShopImport } from './routes/_app/shop'
import { Route as AppScanCodeImport } from './routes/_app/scan-code'
import { Route as AppScanBagImport } from './routes/_app/scan-bag'
import { Route as AppRewardsImport } from './routes/_app/rewards'
import { Route as AppReportIssueImport } from './routes/_app/report-issue'
import { Route as AppPastWinnersImport } from './routes/_app/past-winners'
import { Route as AppInformExistingImport } from './routes/_app/inform-existing'
import { Route as AppHomeImport } from './routes/_app/home'
import { Route as AppHelpImport } from './routes/_app/help'
import { Route as AppEnterCodeImport } from './routes/_app/enter-code'
import { Route as AppDeleteAccountImport } from './routes/_app/delete-account'
import { Route as AppChooseSubscriptionImport } from './routes/_app/choose-subscription'
import { Route as AppCheckoutProductImport } from './routes/_app/checkout-product'
import { Route as AppChangePasswordImport } from './routes/_app/change-password'
import { Route as AppCancelAutoRenewImport } from './routes/_app/cancel-auto-renew'
import { Route as AppBillingImport } from './routes/_app/billing'
import { Route as AppBagScannedImport } from './routes/_app/bag-scanned'
import { Route as AppAppUpdatesImport } from './routes/_app/app-updates'
import { Route as AppAlertsImport } from './routes/_app/alerts'
import { Route as AppAccountImport } from './routes/_app/account'
import { Route as AppAboutSubscriptionsImport } from './routes/_app/about-subscriptions'
import { Route as AppSubscriptionDetailProductIdImport } from './routes/_app/subscription-detail.$productId'
import { Route as AppCheckoutSubscriptionProductPriceIdImport } from './routes/_app/checkout-subscription.$productPriceId'
import { Route as AppCheckoutSubscriptionResultSessionIdImport } from './routes/_app/checkout-subscription-result.$sessionId'
import { Route as AppCheckoutProductResultSessionIdImport } from './routes/_app/checkout-product-result.$sessionId'

// Create Virtual Routes

const AppIndexLazyImport = createFileRoute('/_app/')()
const AppAboutLazyImport = createFileRoute('/_app/about')()

// Create/Update Routes

const SignupRoute = SignupImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRoute,
} as any)

const RequestPasswordResetRoute = RequestPasswordResetImport.update({
  id: '/request-password-reset',
  path: '/request-password-reset',
  getParentRoute: () => rootRoute,
} as any)

const PasswordLinkSentRoute = PasswordLinkSentImport.update({
  id: '/password-link-sent',
  path: '/password-link-sent',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const AppIndexLazyRoute = AppIndexLazyImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/index.lazy').then((d) => d.Route))

const AppAboutLazyRoute = AppAboutLazyImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/about.lazy').then((d) => d.Route))

const AuthResetPasswordRoute = AuthResetPasswordImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRoute,
} as any)

const AppWelcomeRoute = AppWelcomeImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => AppRoute,
} as any)

const AppTermsRoute = AppTermsImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => AppRoute,
} as any)

const AppSubscriptionRoute = AppSubscriptionImport.update({
  id: '/subscription',
  path: '/subscription',
  getParentRoute: () => AppRoute,
} as any)

const AppSignupDetailsRoute = AppSignupDetailsImport.update({
  id: '/signup-details',
  path: '/signup-details',
  getParentRoute: () => AppRoute,
} as any)

const AppShopRoute = AppShopImport.update({
  id: '/shop',
  path: '/shop',
  getParentRoute: () => AppRoute,
} as any)

const AppScanCodeRoute = AppScanCodeImport.update({
  id: '/scan-code',
  path: '/scan-code',
  getParentRoute: () => AppRoute,
} as any)

const AppScanBagRoute = AppScanBagImport.update({
  id: '/scan-bag',
  path: '/scan-bag',
  getParentRoute: () => AppRoute,
} as any)

const AppRewardsRoute = AppRewardsImport.update({
  id: '/rewards',
  path: '/rewards',
  getParentRoute: () => AppRoute,
} as any)

const AppReportIssueRoute = AppReportIssueImport.update({
  id: '/report-issue',
  path: '/report-issue',
  getParentRoute: () => AppRoute,
} as any)

const AppPastWinnersRoute = AppPastWinnersImport.update({
  id: '/past-winners',
  path: '/past-winners',
  getParentRoute: () => AppRoute,
} as any)

const AppInformExistingRoute = AppInformExistingImport.update({
  id: '/inform-existing',
  path: '/inform-existing',
  getParentRoute: () => AppRoute,
} as any)

const AppHomeRoute = AppHomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)

const AppHelpRoute = AppHelpImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AppRoute,
} as any)

const AppEnterCodeRoute = AppEnterCodeImport.update({
  id: '/enter-code',
  path: '/enter-code',
  getParentRoute: () => AppRoute,
} as any)

const AppDeleteAccountRoute = AppDeleteAccountImport.update({
  id: '/delete-account',
  path: '/delete-account',
  getParentRoute: () => AppRoute,
} as any)

const AppChooseSubscriptionRoute = AppChooseSubscriptionImport.update({
  id: '/choose-subscription',
  path: '/choose-subscription',
  getParentRoute: () => AppRoute,
} as any)

const AppCheckoutProductRoute = AppCheckoutProductImport.update({
  id: '/checkout-product',
  path: '/checkout-product',
  getParentRoute: () => AppRoute,
} as any)

const AppChangePasswordRoute = AppChangePasswordImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => AppRoute,
} as any)

const AppCancelAutoRenewRoute = AppCancelAutoRenewImport.update({
  id: '/cancel-auto-renew',
  path: '/cancel-auto-renew',
  getParentRoute: () => AppRoute,
} as any)

const AppBillingRoute = AppBillingImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppRoute,
} as any)

const AppBagScannedRoute = AppBagScannedImport.update({
  id: '/bag-scanned',
  path: '/bag-scanned',
  getParentRoute: () => AppRoute,
} as any)

const AppAppUpdatesRoute = AppAppUpdatesImport.update({
  id: '/app-updates',
  path: '/app-updates',
  getParentRoute: () => AppRoute,
} as any)

const AppAlertsRoute = AppAlertsImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AppRoute,
} as any)

const AppAccountRoute = AppAccountImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)

const AppAboutSubscriptionsRoute = AppAboutSubscriptionsImport.update({
  id: '/about-subscriptions',
  path: '/about-subscriptions',
  getParentRoute: () => AppRoute,
} as any)

const AppSubscriptionDetailProductIdRoute =
  AppSubscriptionDetailProductIdImport.update({
    id: '/subscription-detail/$productId',
    path: '/subscription-detail/$productId',
    getParentRoute: () => AppRoute,
  } as any)

const AppCheckoutSubscriptionProductPriceIdRoute =
  AppCheckoutSubscriptionProductPriceIdImport.update({
    id: '/checkout-subscription/$productPriceId',
    path: '/checkout-subscription/$productPriceId',
    getParentRoute: () => AppRoute,
  } as any)

const AppCheckoutSubscriptionResultSessionIdRoute =
  AppCheckoutSubscriptionResultSessionIdImport.update({
    id: '/checkout-subscription-result/$sessionId',
    path: '/checkout-subscription-result/$sessionId',
    getParentRoute: () => AppRoute,
  } as any)

const AppCheckoutProductResultSessionIdRoute =
  AppCheckoutProductResultSessionIdImport.update({
    id: '/checkout-product-result/$sessionId',
    path: '/checkout-product-result/$sessionId',
    getParentRoute: () => AppRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/password-link-sent': {
      id: '/password-link-sent'
      path: '/password-link-sent'
      fullPath: '/password-link-sent'
      preLoaderRoute: typeof PasswordLinkSentImport
      parentRoute: typeof rootRoute
    }
    '/request-password-reset': {
      id: '/request-password-reset'
      path: '/request-password-reset'
      fullPath: '/request-password-reset'
      preLoaderRoute: typeof RequestPasswordResetImport
      parentRoute: typeof rootRoute
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupImport
      parentRoute: typeof rootRoute
    }
    '/_app/about-subscriptions': {
      id: '/_app/about-subscriptions'
      path: '/about-subscriptions'
      fullPath: '/about-subscriptions'
      preLoaderRoute: typeof AppAboutSubscriptionsImport
      parentRoute: typeof AppImport
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountImport
      parentRoute: typeof AppImport
    }
    '/_app/alerts': {
      id: '/_app/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AppAlertsImport
      parentRoute: typeof AppImport
    }
    '/_app/app-updates': {
      id: '/_app/app-updates'
      path: '/app-updates'
      fullPath: '/app-updates'
      preLoaderRoute: typeof AppAppUpdatesImport
      parentRoute: typeof AppImport
    }
    '/_app/bag-scanned': {
      id: '/_app/bag-scanned'
      path: '/bag-scanned'
      fullPath: '/bag-scanned'
      preLoaderRoute: typeof AppBagScannedImport
      parentRoute: typeof AppImport
    }
    '/_app/billing': {
      id: '/_app/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AppBillingImport
      parentRoute: typeof AppImport
    }
    '/_app/cancel-auto-renew': {
      id: '/_app/cancel-auto-renew'
      path: '/cancel-auto-renew'
      fullPath: '/cancel-auto-renew'
      preLoaderRoute: typeof AppCancelAutoRenewImport
      parentRoute: typeof AppImport
    }
    '/_app/change-password': {
      id: '/_app/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof AppChangePasswordImport
      parentRoute: typeof AppImport
    }
    '/_app/checkout-product': {
      id: '/_app/checkout-product'
      path: '/checkout-product'
      fullPath: '/checkout-product'
      preLoaderRoute: typeof AppCheckoutProductImport
      parentRoute: typeof AppImport
    }
    '/_app/choose-subscription': {
      id: '/_app/choose-subscription'
      path: '/choose-subscription'
      fullPath: '/choose-subscription'
      preLoaderRoute: typeof AppChooseSubscriptionImport
      parentRoute: typeof AppImport
    }
    '/_app/delete-account': {
      id: '/_app/delete-account'
      path: '/delete-account'
      fullPath: '/delete-account'
      preLoaderRoute: typeof AppDeleteAccountImport
      parentRoute: typeof AppImport
    }
    '/_app/enter-code': {
      id: '/_app/enter-code'
      path: '/enter-code'
      fullPath: '/enter-code'
      preLoaderRoute: typeof AppEnterCodeImport
      parentRoute: typeof AppImport
    }
    '/_app/help': {
      id: '/_app/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof AppHelpImport
      parentRoute: typeof AppImport
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeImport
      parentRoute: typeof AppImport
    }
    '/_app/inform-existing': {
      id: '/_app/inform-existing'
      path: '/inform-existing'
      fullPath: '/inform-existing'
      preLoaderRoute: typeof AppInformExistingImport
      parentRoute: typeof AppImport
    }
    '/_app/past-winners': {
      id: '/_app/past-winners'
      path: '/past-winners'
      fullPath: '/past-winners'
      preLoaderRoute: typeof AppPastWinnersImport
      parentRoute: typeof AppImport
    }
    '/_app/report-issue': {
      id: '/_app/report-issue'
      path: '/report-issue'
      fullPath: '/report-issue'
      preLoaderRoute: typeof AppReportIssueImport
      parentRoute: typeof AppImport
    }
    '/_app/rewards': {
      id: '/_app/rewards'
      path: '/rewards'
      fullPath: '/rewards'
      preLoaderRoute: typeof AppRewardsImport
      parentRoute: typeof AppImport
    }
    '/_app/scan-bag': {
      id: '/_app/scan-bag'
      path: '/scan-bag'
      fullPath: '/scan-bag'
      preLoaderRoute: typeof AppScanBagImport
      parentRoute: typeof AppImport
    }
    '/_app/scan-code': {
      id: '/_app/scan-code'
      path: '/scan-code'
      fullPath: '/scan-code'
      preLoaderRoute: typeof AppScanCodeImport
      parentRoute: typeof AppImport
    }
    '/_app/shop': {
      id: '/_app/shop'
      path: '/shop'
      fullPath: '/shop'
      preLoaderRoute: typeof AppShopImport
      parentRoute: typeof AppImport
    }
    '/_app/signup-details': {
      id: '/_app/signup-details'
      path: '/signup-details'
      fullPath: '/signup-details'
      preLoaderRoute: typeof AppSignupDetailsImport
      parentRoute: typeof AppImport
    }
    '/_app/subscription': {
      id: '/_app/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof AppSubscriptionImport
      parentRoute: typeof AppImport
    }
    '/_app/terms': {
      id: '/_app/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof AppTermsImport
      parentRoute: typeof AppImport
    }
    '/_app/welcome': {
      id: '/_app/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof AppWelcomeImport
      parentRoute: typeof AppImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof rootRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/_app/about': {
      id: '/_app/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AppAboutLazyImport
      parentRoute: typeof AppImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexLazyImport
      parentRoute: typeof AppImport
    }
    '/_app/checkout-product-result/$sessionId': {
      id: '/_app/checkout-product-result/$sessionId'
      path: '/checkout-product-result/$sessionId'
      fullPath: '/checkout-product-result/$sessionId'
      preLoaderRoute: typeof AppCheckoutProductResultSessionIdImport
      parentRoute: typeof AppImport
    }
    '/_app/checkout-subscription-result/$sessionId': {
      id: '/_app/checkout-subscription-result/$sessionId'
      path: '/checkout-subscription-result/$sessionId'
      fullPath: '/checkout-subscription-result/$sessionId'
      preLoaderRoute: typeof AppCheckoutSubscriptionResultSessionIdImport
      parentRoute: typeof AppImport
    }
    '/_app/checkout-subscription/$productPriceId': {
      id: '/_app/checkout-subscription/$productPriceId'
      path: '/checkout-subscription/$productPriceId'
      fullPath: '/checkout-subscription/$productPriceId'
      preLoaderRoute: typeof AppCheckoutSubscriptionProductPriceIdImport
      parentRoute: typeof AppImport
    }
    '/_app/subscription-detail/$productId': {
      id: '/_app/subscription-detail/$productId'
      path: '/subscription-detail/$productId'
      fullPath: '/subscription-detail/$productId'
      preLoaderRoute: typeof AppSubscriptionDetailProductIdImport
      parentRoute: typeof AppImport
    }
  }
}

// Create and export the route tree

interface AppRouteChildren {
  AppAboutSubscriptionsRoute: typeof AppAboutSubscriptionsRoute
  AppAccountRoute: typeof AppAccountRoute
  AppAlertsRoute: typeof AppAlertsRoute
  AppAppUpdatesRoute: typeof AppAppUpdatesRoute
  AppBagScannedRoute: typeof AppBagScannedRoute
  AppBillingRoute: typeof AppBillingRoute
  AppCancelAutoRenewRoute: typeof AppCancelAutoRenewRoute
  AppChangePasswordRoute: typeof AppChangePasswordRoute
  AppCheckoutProductRoute: typeof AppCheckoutProductRoute
  AppChooseSubscriptionRoute: typeof AppChooseSubscriptionRoute
  AppDeleteAccountRoute: typeof AppDeleteAccountRoute
  AppEnterCodeRoute: typeof AppEnterCodeRoute
  AppHelpRoute: typeof AppHelpRoute
  AppHomeRoute: typeof AppHomeRoute
  AppInformExistingRoute: typeof AppInformExistingRoute
  AppPastWinnersRoute: typeof AppPastWinnersRoute
  AppReportIssueRoute: typeof AppReportIssueRoute
  AppRewardsRoute: typeof AppRewardsRoute
  AppScanBagRoute: typeof AppScanBagRoute
  AppScanCodeRoute: typeof AppScanCodeRoute
  AppShopRoute: typeof AppShopRoute
  AppSignupDetailsRoute: typeof AppSignupDetailsRoute
  AppSubscriptionRoute: typeof AppSubscriptionRoute
  AppTermsRoute: typeof AppTermsRoute
  AppWelcomeRoute: typeof AppWelcomeRoute
  AppAboutLazyRoute: typeof AppAboutLazyRoute
  AppIndexLazyRoute: typeof AppIndexLazyRoute
  AppCheckoutProductResultSessionIdRoute: typeof AppCheckoutProductResultSessionIdRoute
  AppCheckoutSubscriptionResultSessionIdRoute: typeof AppCheckoutSubscriptionResultSessionIdRoute
  AppCheckoutSubscriptionProductPriceIdRoute: typeof AppCheckoutSubscriptionProductPriceIdRoute
  AppSubscriptionDetailProductIdRoute: typeof AppSubscriptionDetailProductIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAboutSubscriptionsRoute: AppAboutSubscriptionsRoute,
  AppAccountRoute: AppAccountRoute,
  AppAlertsRoute: AppAlertsRoute,
  AppAppUpdatesRoute: AppAppUpdatesRoute,
  AppBagScannedRoute: AppBagScannedRoute,
  AppBillingRoute: AppBillingRoute,
  AppCancelAutoRenewRoute: AppCancelAutoRenewRoute,
  AppChangePasswordRoute: AppChangePasswordRoute,
  AppCheckoutProductRoute: AppCheckoutProductRoute,
  AppChooseSubscriptionRoute: AppChooseSubscriptionRoute,
  AppDeleteAccountRoute: AppDeleteAccountRoute,
  AppEnterCodeRoute: AppEnterCodeRoute,
  AppHelpRoute: AppHelpRoute,
  AppHomeRoute: AppHomeRoute,
  AppInformExistingRoute: AppInformExistingRoute,
  AppPastWinnersRoute: AppPastWinnersRoute,
  AppReportIssueRoute: AppReportIssueRoute,
  AppRewardsRoute: AppRewardsRoute,
  AppScanBagRoute: AppScanBagRoute,
  AppScanCodeRoute: AppScanCodeRoute,
  AppShopRoute: AppShopRoute,
  AppSignupDetailsRoute: AppSignupDetailsRoute,
  AppSubscriptionRoute: AppSubscriptionRoute,
  AppTermsRoute: AppTermsRoute,
  AppWelcomeRoute: AppWelcomeRoute,
  AppAboutLazyRoute: AppAboutLazyRoute,
  AppIndexLazyRoute: AppIndexLazyRoute,
  AppCheckoutProductResultSessionIdRoute:
    AppCheckoutProductResultSessionIdRoute,
  AppCheckoutSubscriptionResultSessionIdRoute:
    AppCheckoutSubscriptionResultSessionIdRoute,
  AppCheckoutSubscriptionProductPriceIdRoute:
    AppCheckoutSubscriptionProductPriceIdRoute,
  AppSubscriptionDetailProductIdRoute: AppSubscriptionDetailProductIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof AppRouteWithChildren
  '/password-link-sent': typeof PasswordLinkSentRoute
  '/request-password-reset': typeof RequestPasswordResetRoute
  '/signup': typeof SignupRoute
  '/about-subscriptions': typeof AppAboutSubscriptionsRoute
  '/account': typeof AppAccountRoute
  '/alerts': typeof AppAlertsRoute
  '/app-updates': typeof AppAppUpdatesRoute
  '/bag-scanned': typeof AppBagScannedRoute
  '/billing': typeof AppBillingRoute
  '/cancel-auto-renew': typeof AppCancelAutoRenewRoute
  '/change-password': typeof AppChangePasswordRoute
  '/checkout-product': typeof AppCheckoutProductRoute
  '/choose-subscription': typeof AppChooseSubscriptionRoute
  '/delete-account': typeof AppDeleteAccountRoute
  '/enter-code': typeof AppEnterCodeRoute
  '/help': typeof AppHelpRoute
  '/home': typeof AppHomeRoute
  '/inform-existing': typeof AppInformExistingRoute
  '/past-winners': typeof AppPastWinnersRoute
  '/report-issue': typeof AppReportIssueRoute
  '/rewards': typeof AppRewardsRoute
  '/scan-bag': typeof AppScanBagRoute
  '/scan-code': typeof AppScanCodeRoute
  '/shop': typeof AppShopRoute
  '/signup-details': typeof AppSignupDetailsRoute
  '/subscription': typeof AppSubscriptionRoute
  '/terms': typeof AppTermsRoute
  '/welcome': typeof AppWelcomeRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/about': typeof AppAboutLazyRoute
  '/': typeof AppIndexLazyRoute
  '/checkout-product-result/$sessionId': typeof AppCheckoutProductResultSessionIdRoute
  '/checkout-subscription-result/$sessionId': typeof AppCheckoutSubscriptionResultSessionIdRoute
  '/checkout-subscription/$productPriceId': typeof AppCheckoutSubscriptionProductPriceIdRoute
  '/subscription-detail/$productId': typeof AppSubscriptionDetailProductIdRoute
}

export interface FileRoutesByTo {
  '/password-link-sent': typeof PasswordLinkSentRoute
  '/request-password-reset': typeof RequestPasswordResetRoute
  '/signup': typeof SignupRoute
  '/about-subscriptions': typeof AppAboutSubscriptionsRoute
  '/account': typeof AppAccountRoute
  '/alerts': typeof AppAlertsRoute
  '/app-updates': typeof AppAppUpdatesRoute
  '/bag-scanned': typeof AppBagScannedRoute
  '/billing': typeof AppBillingRoute
  '/cancel-auto-renew': typeof AppCancelAutoRenewRoute
  '/change-password': typeof AppChangePasswordRoute
  '/checkout-product': typeof AppCheckoutProductRoute
  '/choose-subscription': typeof AppChooseSubscriptionRoute
  '/delete-account': typeof AppDeleteAccountRoute
  '/enter-code': typeof AppEnterCodeRoute
  '/help': typeof AppHelpRoute
  '/home': typeof AppHomeRoute
  '/inform-existing': typeof AppInformExistingRoute
  '/past-winners': typeof AppPastWinnersRoute
  '/report-issue': typeof AppReportIssueRoute
  '/rewards': typeof AppRewardsRoute
  '/scan-bag': typeof AppScanBagRoute
  '/scan-code': typeof AppScanCodeRoute
  '/shop': typeof AppShopRoute
  '/signup-details': typeof AppSignupDetailsRoute
  '/subscription': typeof AppSubscriptionRoute
  '/terms': typeof AppTermsRoute
  '/welcome': typeof AppWelcomeRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/about': typeof AppAboutLazyRoute
  '/': typeof AppIndexLazyRoute
  '/checkout-product-result/$sessionId': typeof AppCheckoutProductResultSessionIdRoute
  '/checkout-subscription-result/$sessionId': typeof AppCheckoutSubscriptionResultSessionIdRoute
  '/checkout-subscription/$productPriceId': typeof AppCheckoutSubscriptionProductPriceIdRoute
  '/subscription-detail/$productId': typeof AppSubscriptionDetailProductIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_app': typeof AppRouteWithChildren
  '/password-link-sent': typeof PasswordLinkSentRoute
  '/request-password-reset': typeof RequestPasswordResetRoute
  '/signup': typeof SignupRoute
  '/_app/about-subscriptions': typeof AppAboutSubscriptionsRoute
  '/_app/account': typeof AppAccountRoute
  '/_app/alerts': typeof AppAlertsRoute
  '/_app/app-updates': typeof AppAppUpdatesRoute
  '/_app/bag-scanned': typeof AppBagScannedRoute
  '/_app/billing': typeof AppBillingRoute
  '/_app/cancel-auto-renew': typeof AppCancelAutoRenewRoute
  '/_app/change-password': typeof AppChangePasswordRoute
  '/_app/checkout-product': typeof AppCheckoutProductRoute
  '/_app/choose-subscription': typeof AppChooseSubscriptionRoute
  '/_app/delete-account': typeof AppDeleteAccountRoute
  '/_app/enter-code': typeof AppEnterCodeRoute
  '/_app/help': typeof AppHelpRoute
  '/_app/home': typeof AppHomeRoute
  '/_app/inform-existing': typeof AppInformExistingRoute
  '/_app/past-winners': typeof AppPastWinnersRoute
  '/_app/report-issue': typeof AppReportIssueRoute
  '/_app/rewards': typeof AppRewardsRoute
  '/_app/scan-bag': typeof AppScanBagRoute
  '/_app/scan-code': typeof AppScanCodeRoute
  '/_app/shop': typeof AppShopRoute
  '/_app/signup-details': typeof AppSignupDetailsRoute
  '/_app/subscription': typeof AppSubscriptionRoute
  '/_app/terms': typeof AppTermsRoute
  '/_app/welcome': typeof AppWelcomeRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/_app/about': typeof AppAboutLazyRoute
  '/_app/': typeof AppIndexLazyRoute
  '/_app/checkout-product-result/$sessionId': typeof AppCheckoutProductResultSessionIdRoute
  '/_app/checkout-subscription-result/$sessionId': typeof AppCheckoutSubscriptionResultSessionIdRoute
  '/_app/checkout-subscription/$productPriceId': typeof AppCheckoutSubscriptionProductPriceIdRoute
  '/_app/subscription-detail/$productId': typeof AppSubscriptionDetailProductIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/password-link-sent'
    | '/request-password-reset'
    | '/signup'
    | '/about-subscriptions'
    | '/account'
    | '/alerts'
    | '/app-updates'
    | '/bag-scanned'
    | '/billing'
    | '/cancel-auto-renew'
    | '/change-password'
    | '/checkout-product'
    | '/choose-subscription'
    | '/delete-account'
    | '/enter-code'
    | '/help'
    | '/home'
    | '/inform-existing'
    | '/past-winners'
    | '/report-issue'
    | '/rewards'
    | '/scan-bag'
    | '/scan-code'
    | '/shop'
    | '/signup-details'
    | '/subscription'
    | '/terms'
    | '/welcome'
    | '/auth/login'
    | '/auth/reset-password'
    | '/about'
    | '/'
    | '/checkout-product-result/$sessionId'
    | '/checkout-subscription-result/$sessionId'
    | '/checkout-subscription/$productPriceId'
    | '/subscription-detail/$productId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/password-link-sent'
    | '/request-password-reset'
    | '/signup'
    | '/about-subscriptions'
    | '/account'
    | '/alerts'
    | '/app-updates'
    | '/bag-scanned'
    | '/billing'
    | '/cancel-auto-renew'
    | '/change-password'
    | '/checkout-product'
    | '/choose-subscription'
    | '/delete-account'
    | '/enter-code'
    | '/help'
    | '/home'
    | '/inform-existing'
    | '/past-winners'
    | '/report-issue'
    | '/rewards'
    | '/scan-bag'
    | '/scan-code'
    | '/shop'
    | '/signup-details'
    | '/subscription'
    | '/terms'
    | '/welcome'
    | '/auth/login'
    | '/auth/reset-password'
    | '/about'
    | '/'
    | '/checkout-product-result/$sessionId'
    | '/checkout-subscription-result/$sessionId'
    | '/checkout-subscription/$productPriceId'
    | '/subscription-detail/$productId'
  id:
    | '__root__'
    | '/_app'
    | '/password-link-sent'
    | '/request-password-reset'
    | '/signup'
    | '/_app/about-subscriptions'
    | '/_app/account'
    | '/_app/alerts'
    | '/_app/app-updates'
    | '/_app/bag-scanned'
    | '/_app/billing'
    | '/_app/cancel-auto-renew'
    | '/_app/change-password'
    | '/_app/checkout-product'
    | '/_app/choose-subscription'
    | '/_app/delete-account'
    | '/_app/enter-code'
    | '/_app/help'
    | '/_app/home'
    | '/_app/inform-existing'
    | '/_app/past-winners'
    | '/_app/report-issue'
    | '/_app/rewards'
    | '/_app/scan-bag'
    | '/_app/scan-code'
    | '/_app/shop'
    | '/_app/signup-details'
    | '/_app/subscription'
    | '/_app/terms'
    | '/_app/welcome'
    | '/auth/login'
    | '/auth/reset-password'
    | '/_app/about'
    | '/_app/'
    | '/_app/checkout-product-result/$sessionId'
    | '/_app/checkout-subscription-result/$sessionId'
    | '/_app/checkout-subscription/$productPriceId'
    | '/_app/subscription-detail/$productId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  PasswordLinkSentRoute: typeof PasswordLinkSentRoute
  RequestPasswordResetRoute: typeof RequestPasswordResetRoute
  SignupRoute: typeof SignupRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
}

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  PasswordLinkSentRoute: PasswordLinkSentRoute,
  RequestPasswordResetRoute: RequestPasswordResetRoute,
  SignupRoute: SignupRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_app",
        "/password-link-sent",
        "/request-password-reset",
        "/signup",
        "/auth/login",
        "/auth/reset-password"
      ]
    },
    "/_app": {
      "filePath": "_app.tsx",
      "children": [
        "/_app/about-subscriptions",
        "/_app/account",
        "/_app/alerts",
        "/_app/app-updates",
        "/_app/bag-scanned",
        "/_app/billing",
        "/_app/cancel-auto-renew",
        "/_app/change-password",
        "/_app/checkout-product",
        "/_app/choose-subscription",
        "/_app/delete-account",
        "/_app/enter-code",
        "/_app/help",
        "/_app/home",
        "/_app/inform-existing",
        "/_app/past-winners",
        "/_app/report-issue",
        "/_app/rewards",
        "/_app/scan-bag",
        "/_app/scan-code",
        "/_app/shop",
        "/_app/signup-details",
        "/_app/subscription",
        "/_app/terms",
        "/_app/welcome",
        "/_app/about",
        "/_app/",
        "/_app/checkout-product-result/$sessionId",
        "/_app/checkout-subscription-result/$sessionId",
        "/_app/checkout-subscription/$productPriceId",
        "/_app/subscription-detail/$productId"
      ]
    },
    "/password-link-sent": {
      "filePath": "password-link-sent.tsx"
    },
    "/request-password-reset": {
      "filePath": "request-password-reset.tsx"
    },
    "/signup": {
      "filePath": "signup.tsx"
    },
    "/_app/about-subscriptions": {
      "filePath": "_app/about-subscriptions.tsx",
      "parent": "/_app"
    },
    "/_app/account": {
      "filePath": "_app/account.tsx",
      "parent": "/_app"
    },
    "/_app/alerts": {
      "filePath": "_app/alerts.tsx",
      "parent": "/_app"
    },
    "/_app/app-updates": {
      "filePath": "_app/app-updates.tsx",
      "parent": "/_app"
    },
    "/_app/bag-scanned": {
      "filePath": "_app/bag-scanned.tsx",
      "parent": "/_app"
    },
    "/_app/billing": {
      "filePath": "_app/billing.tsx",
      "parent": "/_app"
    },
    "/_app/cancel-auto-renew": {
      "filePath": "_app/cancel-auto-renew.tsx",
      "parent": "/_app"
    },
    "/_app/change-password": {
      "filePath": "_app/change-password.ts",
      "parent": "/_app"
    },
    "/_app/checkout-product": {
      "filePath": "_app/checkout-product.tsx",
      "parent": "/_app"
    },
    "/_app/choose-subscription": {
      "filePath": "_app/choose-subscription.tsx",
      "parent": "/_app"
    },
    "/_app/delete-account": {
      "filePath": "_app/delete-account.tsx",
      "parent": "/_app"
    },
    "/_app/enter-code": {
      "filePath": "_app/enter-code.tsx",
      "parent": "/_app"
    },
    "/_app/help": {
      "filePath": "_app/help.tsx",
      "parent": "/_app"
    },
    "/_app/home": {
      "filePath": "_app/home.tsx",
      "parent": "/_app"
    },
    "/_app/inform-existing": {
      "filePath": "_app/inform-existing.tsx",
      "parent": "/_app"
    },
    "/_app/past-winners": {
      "filePath": "_app/past-winners.tsx",
      "parent": "/_app"
    },
    "/_app/report-issue": {
      "filePath": "_app/report-issue.tsx",
      "parent": "/_app"
    },
    "/_app/rewards": {
      "filePath": "_app/rewards.tsx",
      "parent": "/_app"
    },
    "/_app/scan-bag": {
      "filePath": "_app/scan-bag.tsx",
      "parent": "/_app"
    },
    "/_app/scan-code": {
      "filePath": "_app/scan-code.tsx",
      "parent": "/_app"
    },
    "/_app/shop": {
      "filePath": "_app/shop.tsx",
      "parent": "/_app"
    },
    "/_app/signup-details": {
      "filePath": "_app/signup-details.tsx",
      "parent": "/_app"
    },
    "/_app/subscription": {
      "filePath": "_app/subscription.tsx",
      "parent": "/_app"
    },
    "/_app/terms": {
      "filePath": "_app/terms.tsx",
      "parent": "/_app"
    },
    "/_app/welcome": {
      "filePath": "_app/welcome.tsx",
      "parent": "/_app"
    },
    "/auth/login": {
      "filePath": "auth/login.tsx"
    },
    "/auth/reset-password": {
      "filePath": "auth/reset-password.tsx"
    },
    "/_app/about": {
      "filePath": "_app/about.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/": {
      "filePath": "_app/index.lazy.tsx",
      "parent": "/_app"
    },
    "/_app/checkout-product-result/$sessionId": {
      "filePath": "_app/checkout-product-result.$sessionId.tsx",
      "parent": "/_app"
    },
    "/_app/checkout-subscription-result/$sessionId": {
      "filePath": "_app/checkout-subscription-result.$sessionId.tsx",
      "parent": "/_app"
    },
    "/_app/checkout-subscription/$productPriceId": {
      "filePath": "_app/checkout-subscription.$productPriceId.tsx",
      "parent": "/_app"
    },
    "/_app/subscription-detail/$productId": {
      "filePath": "_app/subscription-detail.$productId.tsx",
      "parent": "/_app"
    }
  }
}
ROUTE_MANIFEST_END */
